import ReplayContainer from '../components/replay/replay-container'

export default ReplayContainer